import ContractInits from "../config/contractsInit";
import {
  onSetStakeLoading,
  onSetTransactionMessage,
  onToast,
} from "./layoutActions";
import Web3 from "web3";
import { PHNX_STAKING_ADDRESS } from "../../contracts/phnxStaking";
import { getBalance } from "./dashboardActions";
import { faCommentDollar } from "@fortawesome/free-solid-svg-icons";
import { GetDashboardData } from "../../Config/graphQL";

// This is for check approval
export const onGetIsUnlock = (address) => {
  // console.log("onGetIsUnlock stakeAction");
  return async (dispatch) => {
    try {
      if (address) {
        const res = await (await ContractInits.initPhnxTokenContract()).methods
          .allowance(address, PHNX_STAKING_ADDRESS)
          .call();
        if (res != 0) {
          // console.log("Res of onGetIsUnlock", res);
          dispatch({
            type: "getUnlock",
            payload: true,
          });
        } else if (res == 0) {
          dispatch({
            type: "getUnlock",
            payload: false,
          });
        }
      }
    } catch (e) {
      console.error("ERROR onGetIsUnlock => ", e);
    }
  };
};

export const onGetPhnxLimit = () => {
  return async (dispatch) => {
    try {
      const phnxStakingContract = await ContractInits.initPhnxStakingContract();
      const { web3js } = await ContractInits.init();
      const res = await phnxStakingContract.methods.maxStakedQuantity().call();
      const phnx = await web3js.utils.fromWei(res.toString());
      dispatch({
        type: "onPhnxLimit",
        payload: phnx,
      });
    } catch (e) {
      console.error("ERROR onGetPhnxLimit => ", e);
    }
  };
};

export const onGetDaysLimit = () => {
  return async (dispatch) => {
    try {
      let res = 365;
      dispatch({
        type: "onDaysLimit",
        payload: res,
      });
    } catch (e) {
      console.error("ERROR onGetDaysLimit => ", e);
    }
  };
};

export const onGetInterestRate = (amountPhnxInput, durationDaysInput) => {
  // console.log("checking props.getintersrrate");
  return async (dispatch, getState) => {
    try {
      // console.log("get State -->", getState().stakeReducer);
      const res = await (await ContractInits.initPhnxStakingContract()).methods
        .ratio()
        .call();

      const interestRate =
        (res / 10000) * amountPhnxInput * (durationDaysInput / 365);

      dispatch({
        type: "onInterestRate",
        payload: interestRate,
      });
    } catch (e) {
      console.error("ERROR onGetInterestRate => ", e);
    }
  };
};

export const onApprove = (isUnlock, address) => {
  return async (dispatch) => {
    try {
      if (!address) {
        dispatch(onToast("PLEASE CONNECT TO METAMASK TO CONTINUE"));
        return;
      }
      if (isUnlock) {
        dispatch(onToast("PHNX Approved, you can start staking now."));
        return;
      }
      if (address) {
        dispatch(
          onSetTransactionMessage({
            message: "PLEASE CONFIRM PERMISSION TO START STAKING.",
            hash: "",
          })
        );
        dispatch(onSetStakeLoading(true));

        const _approve = await (
          await ContractInits.initPhnxTokenContract()
        ).methods
          .approve(
            PHNX_STAKING_ADDRESS,
            "0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"
          )
          .send({
            from: address,
          })
          .on("confirmation", (num) => {
            if (num != null) {
              GetDashboardData(address);
              dispatch(onGetIsUnlock(address));
              dispatch(
                onToast(
                  "You have successfully approved PHNX and can now begin staking."
                )
              );
              dispatch(onSetStakeLoading(false));
            }
          });
        // dispatch(onSetTransactionMessage({ message: "", hash: "" }));
      } else {
        dispatch(onToast("PLEASE CONNECT TO METAMASK WALLET"));
      }
    } catch (e) {
      // console.error("ERROR onApprove => ", e);

      dispatch(onSetStakeLoading(false));
      dispatch(onToast("Approval rejected!"));
    }
  };
};

export const onSetInterestRate = (interest) => {
  return {
    type: "onInterestRate",
    payload: interest,
  };
};

export const onSetInitial = () => {
  return {
    type: "onInitial",
    payload: true,
  };
};

export const onSetPhnx = (phnx) => {
  return {
    type: "onPhnx",
    payload: phnx,
  };
};

export const onSetDays = (days) => {
  return {
    type: "onDays",
    payload: days,
  };
};

export const onSetToken = (token) => {
  return {
    type: "onToken",
    payload: token,
  };
};

export const onConfirmStake = (
  address,
  balance,
  stakeAmount,
  interestRate,
  stakeDuration,
  isUnlock,
  minimumStake,
  setAmountPHNX,
  setDurationDays
  // getDashboardData
) => {
  return async (dispatch) => {
    try {
      // console.log("I am here");
      const { web3js } = await ContractInits.init();
      if (address) {
        if (!isUnlock) {
          dispatch(onToast("Approve PHNX First."));
          return;
        }
        if (Number(balance) < Number(stakeAmount)) {
          dispatch(
            onToast(
              "You have insufficient amount of PHNX to make this transaction."
            )
          );
          return;
        }
        if (Number(stakeAmount) < Number(minimumStake)) {
          dispatch(onToast(`You can stake minimum ${minimumStake} PHNX`));
          return;
        }
        if (Number(stakeDuration) <= 0) {
          dispatch(onToast(`You can stake for minimum of 1 day.`));
          return;
        }
        dispatch(onSetStakeLoading(true));
        dispatch(
          onSetTransactionMessage({
            message: "PLEASE CONFIRM STAKE TRANSACTION IN YOUR WALLET",
            hash: "",
          })
        );

        const phnxContract = await ContractInits.initPhnxStakingContract();

        const res = phnxContract.methods
          .stakeALT(Web3.utils.toWei(stakeAmount), stakeDuration)
          .send({
            from: address,
          })
          .on("confirmation", function (confNumber, receipt) {
            //

            if (confNumber == 1) {
              dispatch(onSetStakeLoading(false));
              setTimeout(() => {
                dispatch(
                  onToast(
                    `You have successfully staked ${stakeAmount} PHNX and can unlock these tokens after ${
                      stakeDuration / 86400
                    } days.`
                  )
                );
              }, 2000);
              setAmountPHNX("");
              setDurationDays("");
              GetDashboardData(address);
              dispatch(getBalance(address));
              dispatch(onSetPhnx(0));
              dispatch(onSetDays(0));
              dispatch(onSetInterestRate(0));
            }
            // console.log("confNumber =>>", confNumber);

            dispatch({
              type: "stakeConfirmationNumber",
              payload: confNumber,
            });

            if (confNumber == 24) {
              dispatch({
                type: "stakeConfirmationNumber",
                payload: 0,
              });
            }

          });
      }
    } catch (e) {
      console.error("ERROR onConfirmStake => ", e);
      dispatch(onToast("Transaction rejected!"));
      dispatch(onSetStakeLoading(false));
    }
    // finally {
    //   setAmountPHNX("");
    //   setDurationDays("");
    // GetDashboardData(address);
    // }
  };
};

export const LogoutAppAction = () => {
  return {
    type: "LOGOUT_APP",

  };
};
